import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { Icon } from "@iconify/react";
import { Button, Dialog } from "@mui/material";
import "./ApprovalDialog.css";
import "../Components/Components.css";
import { setContactPhoneApproval } from "../Store/Actions/ContactAction";
import { SET_SELECTED_APPROVAL } from "../Store/Types/AgentTypes";

const ApprovalDialog = ({
  isOpen,
  setIsApprovalDialogShown,
  request,
  fetchApproval,
}) => {
  const dispatch = useDispatch();
  const { myInfo } = useSelector((state) => state.auth);

  const handleClose = () => {
    dispatch({
      type: SET_SELECTED_APPROVAL,
      payload: null,
    });

    setIsApprovalDialogShown(false);
  };

  const handleContactApproval = (status) => {
    setContactPhoneApproval({
      id: request.ID,
      approvedby: myInfo.user.AgentID,
      approvedtime: moment().format("YYYY-MM-DD HH:mm:ss"),
      status: status,
    })
      .then((response) => {
        if (response.status) {
          console.log("Set approval ID:", response.data);

          status === "APPROVE"
            ? toast.success(`Updated Contact: ${request.ContactName}`, {
                autoClose: 3000,
              })
            : toast.info(`Request rejected: ${request.ContactName}`, {
                autoClose: 3000,
              });

          handleClose();
          fetchApproval();
        } else {
          console.log("error", response.error);
          toast.error(response.error, { autoClose: 3000 });
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error(err, { autoClose: 3000 });
      });
  };

  return (
    <Dialog
      open={isOpen}
      className="dialog approval-dialog"
      fullWidth
      maxWidth="sm"
      scroll="paper"
      onClose={handleClose}
    >
      <header>
        <Icon height="28" icon="ion:warning" width="28" />
        <p>Warning!</p>
        <Icon height="28" icon="ion:warning" width="28" />
      </header>

      <div className="dialog-content">
        <p>
          {request?.CreatedBy} has Added Changes into (
          {request?.ContactName?.trim()})
        </p>
        <p>Allow the Changes?</p>

        <div className="buttons">
          <Button
            className="cancel"
            variant="outlined"
            onClick={() => handleClose()}
          >
            Cancel
          </Button>

          <Button
            className="reject"
            variant="outlined"
            onClick={() => handleContactApproval("CANCEL")}
          >
            Reject
          </Button>

          <Button
            variant="contained"
            onClick={() => handleContactApproval("APPROVE")}
          >
            Allow
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ApprovalDialog;
